import styled from "styled-components";

export const SOnboardingTemplatesModalSiderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
